import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { membershipExistsByEmail } from 'src/app/shared/api/payments';
import { useLoginState } from 'src/app/shared/hooks/session';

import { usePromoteFormData } from '../../../formContext/formData';

export function useIsExistingMember(): () => Promise<boolean> {
	const { user } = usePromoteFormData();

	const utilityContext = useUtilityContext();
	const loginState = useLoginState();
	return async function isExistingMember(): Promise<boolean> {
		if (loginState !== 'GUEST') {
			return false;
		}

		return membershipExistsByEmail({ email: user.email }, utilityContext);
	};
}
